import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import './Setting.css'
import { loadAbout, loadPrivacy, updateAbout, updatePrivacy } from '../../Redux/Actions/ActionSetting';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function Setting() {
    let dispatch = useDispatch();
    let langLocal = localStorage.getItem('absherLang');
    const [t, i18n] = useTranslation();
    const [content, setContent] = useState('')
    const [content1, setContent1] = useState('')
    const about = useSelector(state => state.settings.about)
    const loadingAbout = useSelector(state => state.settings.loadingAbout)
    const privacy = useSelector(state => state.settings.privacy)
    const loadingprivacy = useSelector(state => state.settings.loadingprivacy)
    const [loadBtn, setloabBtn] = useState(false)
    const [loadBtn1, setloabBtn1] = useState(false)
    useEffect(() => {
        dispatch(loadAbout());
        dispatch(loadPrivacy());
    }, [])
    useEffect(() => {
        setContent(about.content)
        setContent1(privacy.content)
    }, [about, privacy])
    const FunSubmitAbout = (e) => {
        e.preventDefault()
        dispatch(updateAbout(content, setloabBtn))
    }
    const FunSubmitPrivacy = (e) => {
        e.preventDefault()
        dispatch(updatePrivacy(content1, setloabBtn1))
    }
    const modules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['bold', 'italic', 'underline'],
            [{ 'align': [] }],
            [{ 'color': [] }], // زر تحديد اللون
        ],
    };

    const formats = [
        'header', 'font', 'list', 'bullet', 'bold', 'italic', 'underline', 'align', 'link', 'image', 'color',
    ];
    return (
        <main>
            <div className="page_header" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                <h2>{t('setting')}</h2>
            </div>
            <div className='allsetting' dir={langLocal == "ar" ? "rtl" : "ltr"} >
                <div className='setting_about' >
                    <h3>{t('about')}</h3>
                    <ReactQuill
                        className='input_quill11'
                        modules={modules}
                        formats={formats}
                        value={content}
                        onChange={(e) => setContent(e)}
                    />
                    <button className='set_btn' onClick={FunSubmitAbout} >
                        {
                            loadBtn ? "Loading ... " : <>{t('editabout')}</>
                        }
                    </button>
                </div>
                <div className='setting_privacy' >
                    <h3>{t('privacy')}</h3>
                    <ReactQuill
                        className='input_quill11'
                        modules={modules}
                        formats={formats}
                        value={content1}
                        onChange={(e) => setContent1(e)}
                    />
                    <button className='set_btn' onClick={FunSubmitPrivacy} >
                        {
                            loadBtn1 ? "Loading ... " : <>{t('editprivacy')}</>
                        }
                    </button>
                </div>
            </div>
        </main>
    )
}

export default Setting